import * as React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    badge: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: "70px",
      height: "50px",
      margin: "0 0.5rem",
      backgroundImage: 'url("/assets/images/yoello-logo.svg")',
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
    text: {
      fontSize: "1rem",
      color: "#8D98B7",
      margin: "0 0.5rem",
    },
  })
);

export interface BadgeProps {
  text: string;
}

const Badge = (props: BadgeProps) => {
  const { text } = props;

  const classes = useStyles();

  return (
    <div className={classes.badge}>
      <div className={classes.image}></div>

      <div className={classes.text}>{text}</div>
    </div>
  );
};

export default Badge;
